var _rect, _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.676331,
    y: 0.435547,
    width: 39.6474,
    height: 39.6474,
    rx: 19.8237,
    fill: "#2980FE"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_72_3103)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_72_3103",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 12,
    width: 25,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.9817 12.1831H8.01849V28.3357H32.9817V12.1831Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_72_3103)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8082 12.2422H17.6421H8.78191C8.35979 12.2422 8.01849 12.5832 8.01849 13.0049V16.1009C8.01849 16.5226 8.35979 16.8636 8.78191 16.8636H10.8611H11.6874V17.7789V27.5781C11.6874 27.9999 12.0287 28.3409 12.4508 28.3409H15.7021C16.1242 28.3409 16.4655 27.9999 16.4655 27.5781V17.7789V17.6937V16.8636H17.2918H17.6286H17.7948C19.0701 16.8636 20.1075 15.8272 20.1075 14.5529C20.1209 13.2786 19.0836 12.2422 17.8082 12.2422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5923 12.2422C23.0626 12.2422 20.1975 15.1048 20.1975 18.6314C20.1975 18.6398 20.1975 18.6482 20.1976 18.6566V27.5557C20.1976 27.9774 20.5389 28.3184 20.961 28.3184H24.3829C24.805 28.3184 25.1463 27.9774 25.1463 27.5557V24.8581L25.1503 24.859L25.1658 24.8614C25.3364 24.9018 25.4961 24.9308 25.6757 24.9578C25.9271 24.9937 26.1876 25.0161 26.4481 25.0206L26.5922 25.0206C26.718 25.0206 26.8393 25.0162 26.9605 25.0117C30.3196 24.8187 32.987 22.0369 32.987 18.6314C32.9915 15.1048 30.1265 12.2422 26.5923 12.2422ZM26.9605 20.0223C26.8438 20.0537 26.718 20.0716 26.5923 20.0716C26.5577 20.0716 26.5272 20.0711 26.493 20.0671C25.7556 20.0186 25.1702 19.4148 25.1508 18.6695V18.6314C25.1508 17.8373 25.7974 17.1912 26.5923 17.1912C27.3871 17.1912 28.0338 17.8373 28.0338 18.6314C28.0338 19.3 27.5802 19.8608 26.9605 20.0223Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_72_3103"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.9632,
    height: 16.1526,
    fill: "white",
    transform: "translate(8.01849 12.1831)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTp);
export default __webpack_public_path__ + "static/media/tp.062b19fe66d5281f6a9f9338654f1f8a.svg";
export { ForwardRef as ReactComponent };